import { route } from 'preact-router';
import { useState } from 'preact/hooks';
import { Button } from '../../components/ui/Button.js';
import { api } from '../../services/api.js';

interface ForgotPasswordPageProps {
  path?: string;
}

export function ForgotPasswordPage(_props: ForgotPasswordPageProps) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e: Event) {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await api.post('/auth/forgot-password', { email });
      setSubmitted(true);
    } catch (err) {
      setError((err as { message?: string }).message ?? 'Something went wrong. Try again.');
    } finally {
      setLoading(false);
    }
  }

  if (submitted) {
    return (
      <div className="page-fill bg-bg flex flex-col items-center justify-center px-4">
        <div className="w-full max-w-sm text-center">
          <h1 className="text-2xl font-bold text-text mb-4">Check your email</h1>
          <p className="text-gray-400 mb-6">
            We sent a password reset link to <span className="text-text">{email}</span>.
          </p>
          <button
            type="button"
            className="text-sm text-primary underline"
            onClick={() => route('/account/login')}
          >
            Go to login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="page-fill bg-bg flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <h1 className="text-3xl font-bold text-text mb-2">Forgot Password</h1>
        <p className="text-gray-400 mb-8">Enter your email and we'll send you a reset link.</p>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div className="flex flex-col gap-1">
            <label for="fp-email" className="text-sm text-gray-400">
              Email
            </label>
            <input
              id="fp-email"
              type="email"
              required
              className="bg-surface-mid text-text rounded-lg px-4 py-3"
              value={email}
              onInput={(e) => setEmail((e.target as HTMLInputElement).value)}
              autoComplete="email"
            />
          </div>
          {error && <p className="text-sm text-red-400">{error}</p>}
          <Button type="submit" loading={loading} className="w-full mt-2">
            Send Reset Link
          </Button>
        </form>

        <div className="mt-4 text-center">
          <button
            type="button"
            className="text-sm text-gray-400 underline"
            onClick={() => route('/account/login')}
          >
            Back to login
          </button>
        </div>
      </div>
    </div>
  );
}
